export function useRegistrationFormDialog() {
  const isOpen = useState<boolean>('registration-form-dialog-open', () => false)

  function open() {
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  return {
    isOpen,
    open,
    close,
  }
}
